import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import {
  IReducerSubGroupState,
  FETCH_SUB_GROUP,
  FETCH_SUB_GROUPS,
  SubGroupActionTypes,
} from './types';

const initialState: IReducerSubGroupState = {
  all: undefined,
  current: undefined,
};

const persistConfig = {
  storage,
  key: 'sub-groups',
  whitelist: ['all'],
};

const reducers = (state = initialState, action: SubGroupActionTypes) => {
  switch (action.type) {
    case FETCH_SUB_GROUPS:
      return {
        ...state,
        all: action.payload,
      };
    case FETCH_SUB_GROUP:
      return {
        ...state,
        current: action.payload,
      };

    default:
      return state;
  }
};

export default persistReducer(persistConfig, reducers);
